module.exports = __webpack_public_path__ + "img/15_life_on_land.2e0249d1.svg";